module.exports = __webpack_public_path__ + "static/media/08.24174416.webp";